import { Button } from 'components/common';

interface Brokerage {
  id: number;
  name: string;
  logo_path: string;
}
interface JoinRequest {
  id: number;
  brokerage: Brokerage;
}

interface PendingJoinRequestCardProps {
  joinRequest: JoinRequest;
  onShowModal: () => void;
}

const PendingJoinRequestCard = ({ joinRequest, onShowModal }: PendingJoinRequestCardProps) => (
  <div className="card" data-testid="join-request-pending-card">
    <div className="card-header fw-bold h4">Pending request</div>
    <p className="card-header pt-3">
      Your request to join this team is pending admin approval. You can cancel to request a different team.
    </p>
    <div className="card-body pt-2">
      <div className="d-flex flex-column w-100">
        <div className="align-items-center d-flex fw-bold py-3 justify-content-between">
          <div className="align-items-center d-flex gap-2" data-testid="join-request-pending-card-brokerage-name">
            <div
              className="background-center-contain flex-shrink-0 rounded-circle shadow-2"
              data-testid="team-info-logo"
              style={{
                backgroundImage: `url(${joinRequest.brokerage?.logo_path ?? '/images/spotlight-logo-200x200.png'})`,
                height: 50,
                width: 50,
              }}
            />
            {joinRequest.brokerage?.name}
          </div>
          <Button onClick={onShowModal} text="bold" variant="border-danger">
            Cancel request
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default PendingJoinRequestCard;
